import { Component } from '@angular/core';
import { ChartComponent } from '../charts/chart.component';
import { FilteredReport } from '../filtered-report';
import { FiltersComponent } from '../filters/filters.component';
import { LeaveData } from '../workforce.types';

@Component({ selector: 'app-leave-map', standalone: false, templateUrl: './leave-map.component.html' })
export class LeaveMapComponent extends FilteredReport<LeaveData> {
  protected readonly endpoint = '/workforce/leave-map';
  protected readonly fallbackError = 'Unable to load leave data. Please retry.';
  private readonly colors = ['#60259e', '#008aa5', '#167544', '#b42318', '#966500', '#4355aa', '#a03779', '#467585', '#80551c', '#768b2c', '#bb6347'];
  private chartSource: LeaveData | null = null;
  private cachedSeries: Array<{ key: string; label: string; color: string }> = [];
  private cachedChartRows: object[] = [];

  private refreshChartData(): void {
    if (this.chartSource === this.data) return;
    this.chartSource = this.data;
    this.cachedSeries = (this.data?.leaveTypes ?? []).map((type, index) => ({
      key: `leaveType_${type.code}`, label: type.label, color: this.colors[index % this.colors.length],
    }));
    this.cachedChartRows = (this.data?.leaveByDepartment ?? []).map(row => {
      const values: Record<string, number> = {};
      Object.keys(row.leaveTypeDays ?? {}).forEach(code => { values[`leaveType_${code}`] = row.leaveTypeDays[code]; });
      return { ...row, ...values };
    });
  }

  get series(): Array<{ key: string; label: string; color: string }> {
    this.refreshChartData();
    return this.cachedSeries;
  }
  get chartRows(): object[] {
    this.refreshChartData();
    return this.cachedChartRows;
  }
  get groupLabel(): string { return this.groupBy.charAt(0).toUpperCase() + this.groupBy.slice(1); }
  get chartWidth(): number { return Math.max(900, (this.data?.leaveByDepartment?.length ?? 0) * Math.max(130, this.series.length * 34)); }
  rate(value: number | null): string { return value == null ? 'NIL' : `${value}%`; }
}
